import { PERSONA_SCRIPT_MAX_ALTERNATE_HOOKS } from "@nexus/contracts";

import type { PersonaScriptDto } from "@/features/persona-opportunities/api/persona-opportunity-scripts.api";

/** How many more alternates the script can take; a script without hook data reads as one primary. */
export function remainingAlternateHookCapacity(script: PersonaScriptDto): number {
  const alternates = Math.max((script.hooks?.length ?? 1) - 1, 0);
  return Math.max(PERSONA_SCRIPT_MAX_ALTERNATE_HOOKS - alternates, 0);
}

export function canShowAddThreeHooks(args: {
  canGenerateScripts: boolean;
  script: PersonaScriptDto;
  siblings: PersonaScriptDto[];
  /** True while an order line for the script is open — its hook set is frozen. */
  isSent: boolean;
}): boolean {
  if (!args.canGenerateScripts) return false;
  if (args.script.status !== "READY") return false;
  if (args.script.parentScriptId) return false;
  if (args.siblings.some((sibling) => sibling.parentScriptId === args.script.id)) {
    return false;
  }
  if (args.isSent) return false;
  return remainingAlternateHookCapacity(args.script) > 0;
}

export function shouldOpenHookVariationsPanel(
  correlationId: string,
  discardedCorrelationIds: ReadonlySet<string>,
): boolean {
  return !discardedCorrelationIds.has(correlationId);
}
